//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Data_Check, Filter_Check_CCP_Reports } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Filter_Check_CCP.interface';
import { Download_CPP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Download_ALL_Files.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { FILE_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/File_CCP.interface';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';


@Component({
    selector: 'app-reportslist-lib-ccp',
    templateUrl: './reportslist-lib-ccp.component.html',
    styleUrls: ['./reportslist-lib-ccp.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/ReportListGlobal.css',],
    standalone: false
})
export class ReportslistLibCCPComponent implements OnInit {

  //+================== VARIABLES FOR TITLES ==================+\\
  public TitleTypeCCP: string = 'Generales';

  //+================== TYPE CCP ==================+\\
  public OptionsTypeCCP = [
    { value: 4, item: 'Generales' },
    { value: 1, item: 'Aprobadas' },
    { value: 2, item: 'Pendientes' },
    { value: 3, item: 'Rechazadas' },
  ];

  //+================== VARIABLES FOR HEADERS RL ==================+\\
  public HeadersRL: Headers_CCP[] = [
    { ID: 1, Name: 'Ubicación', Position: 1, Visible: true, Key_Header: 'UBI' },
    { ID: 1, Name: 'Nombre de CCP', Position: 1, Visible: true, Key_Header: 'NAM' },
    { ID: 1, Name: 'Código CCP', Position: 1, Visible: true, Key_Header: 'COD' },
    { ID: 1, Name: 'Numero de Revisión', Position: 1, Visible: true, Key_Header: 'NOR' },
    { ID: 1, Name: 'Año de modelo', Position: 1, Visible: true, Key_Header: 'MOY' },
    { ID: 1, Name: 'Folio', Position: 1, Visible: true, Key_Header: 'INV' },
    { ID: 1, Name: 'Contribuidor', Position: 1, Visible: true, Key_Header: 'CON' },
    { ID: 1, Name: 'Aprobador', Position: 1, Visible: true, Key_Header: 'APP' },
    { ID: 1, Name: 'Revisor', Position: 1, Visible: true, Key_Header: 'REV' },
    { ID: 1, Name: 'Fecha de Modificación', Position: 1, Visible: true, Key_Header: 'DAM' },
    { ID: 1, Name: 'En revisión con usuario', Position: 1, Visible: true, Key_Header: 'USASS' },
    { ID: 1, Name: 'Usuario que rechazo', Position: 1, Visible: true, Key_Header: 'USREJ' },
    { ID: 1, Name: 'Razón de rechazo', Position: 1, Visible: true, Key_Header: 'REASO' },
    { ID: 1, Name: 'Estatus', Position: 1, Visible: true, Key_Header: 'EST' },
  ];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR KEY SNAPSHOTS ==================+\\
  public ValueTypeCCP: number = 4;
  private Route_Level: string = '';

  //+================== VARIABLES FOR REPORTS LIST ==================+\\
  public Data_Report_List: FILE_CCP[] = [];
  public SelectedData_Report_List: FILE_CCP[] = [];
  public Load_Page: boolean = false;

  //+================== VARIABLES FOR REGULAR EXPRESION ==================+\\
  private Expression1: RegExp = /[/]+[0-9]+§/

  //+================== SEARCH ==================+\\
  public Filter_RList: string = '';

  //+================== FOR FILTERS ==================+\\
  public Filter_Global_Check: Filter_Check_CCP_Reports = {
    Extension: [],
    Model_Year: [],
    Status: [],
    Reviewer_Name: [],
    Approver_Name: [],
    Contributor_Name: [],
    Approver_Assigned: [],
    Approver_Rejected: [],
  };

  constructor(private Service_CCP: LIBRARYCCPService, private router: Router, private ActivatedRouter: ActivatedRoute) {
    this.ValueTypeCCP = Number(this.ActivatedRouter.snapshot.params['T']);
    this.Route_Level = this.ActivatedRouter.snapshot.params['R'];
  }

  ngOnInit(): void {
    this.Load_Data(this.ValueTypeCCP, this.Route_Level);
  }

  private async Load_Data(TypeReportCCP: number, Route: string): Promise<void> {
    this.Load_Page = false;

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      if (Route === 'Root') Route = '';
      if (this.Route_Level === 'Root') this.Route_Level = '';


      const ResGetDataList: Response_CCP = await firstValueFrom(this.Service_CCP.ReportList({ Path: Route, Status: TypeReportCCP }))

      if (ResGetDataList.success) {
        this.Data_Report_List = ResGetDataList.operation;
        this.Generate_Filters();
      }


      Loader.classList.remove('active');
      this.Load_Page = true;

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error',
        text: '¡Recargue la página, si el problema persiste notifique al supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })

      Loader.classList.remove('active');
      this.Load_Page = true;
    }
  }





  //&===================== FUNCTIONS FOR GENERAL REPORT LIST =====================&\\

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date | null): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-================ FUNCTION FOR CLEAN ROUTE ================-\\
  public Clean_Route(Route: string): string {

    const Route_Add: string = '/' + Route;

    const Route_Clean: string = Route_Add.split(this.Expression1).join('/');

    return Route_Clean.replace('/', '');
  }

  //-================== FUNCTION FOR CUT DESCRIPTION ==================-\\
  public Cut_Reason(Reason: string | null): string {
    return Reason === null ? 'Rechazado por administrador' : Reason.length > 32 ? Reason.slice(0, 32) + '...' : Reason;
  }

  //-================== FUNCTION FOR SEE Reason COMPLETE ==================-\\
  public See_Reason(Reason: string | null): void {
    Reason = Reason === null ? 'Rechazado por administrador' : Reason;
    Swal.fire({
      title: 'Razón de rechazo',
      text: Reason,
      confirmButtonColor: this.ColorConfirm
    })
  }


  //-================ FUNCTION FOR STATUS STRING ================-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobada';
      case 2: return 'Pendiente';
      case 3: return 'Rechazada';
      case 4: return 'Eliminada';
      default: return '';
    }
  }

  //-================ FUNCTION FOR STATUS TYPE SQUARE ================-\\
  public Status_Type(Status: number): string {

    switch (Status) {
      case 1: return 'Approved';
      case 2: return 'Pending';
      case 3: return 'Reject';
      default: return '';
    }
  }

  //-================ FUNCTION FOR SEE CCP IN LIBRARY ================-\\
  public SeeCCPLibrary(Route: string): void {

    this.router.navigate([`Dashboard/CCP/FMLibraryCCP/${encodeURIComponent(Route)}`]);

  }


  //&===================== END FUNCTIONS FOR GENERAL REPORT LIST =====================&\\




  //&===================== FUNCTIONS FOR CARD OPTIONS =====================&\\

  //-================== TYPE REPORT CCP ==================-\\
  public ChangeTypeCCP(): void {
    this.TitleTypeCCP = (this.OptionsTypeCCP.find((item) => (item.value === this.ValueTypeCCP)))?.item!;
    this.Load_Data(this.ValueTypeCCP, this.Route_Level);
  }

  //-================== REPORT DOWNLOAD PDF ==================-\\
  public async DownloadReportPDF() {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const ResDownloadPDF: Response_CCP = await firstValueFrom(this.Service_CCP.Generate_RL_PDF({ Path: this.Route_Level, Status: this.ValueTypeCCP }));

      if (ResDownloadPDF.success) {

        const URL: string = ResDownloadPDF.operation.URL;
        const File_Name: string = decodeURIComponent(URL).split('/').pop() || '';

        const File_Name_Download: string = `Report_List_${this.TitleTypeCCP}.${File_Name.split('.').pop()}`

        const IsDownload: boolean = await this.Download_File_CCP(URL, File_Name_Download);

        if (IsDownload)
          this.Delete_File_Temp_RL_CCP(File_Name)

      }


    } catch (e) {
      ProgressModal.classList.remove('active');
      Swal.fire({
        title: 'Error al descargar el reporte',
        text: `¡Ocurrió un error al descargar el reporte listado (PDF), inténtelo de nuevo, si el problema persiste notifique a su supervisor!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })
    }
  }

  //-================== REPORT DOWNLOAD PDF ==================-\\
  public async DownloadReportXLSX() {

    const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
    ProgressModal.classList.add('active');

    try {

      const ResDownloadXLSX: Response_CCP = await firstValueFrom(this.Service_CCP.Generate_RL_XLSX({ Path: this.Route_Level, Status: this.ValueTypeCCP }));

      if (ResDownloadXLSX.success) {

        const URL: string = ResDownloadXLSX.operation.URL;
        const File_Name: string = decodeURIComponent(URL).split('/').pop() || '';

        const File_Name_Download: string = `Report_List_${this.TitleTypeCCP}.${File_Name.split('.').pop()}`

        const IsDownload: boolean = await this.Download_File_CCP(URL, File_Name_Download);

        if (IsDownload)
          this.Delete_File_Temp_RL_CCP(File_Name)

      }


    } catch (e) {
      ProgressModal.classList.remove('active');
      Swal.fire({
        title: 'Error al descargar el reporte',
        text: `¡Ocurrió un error al descargar el reporte listado (XLSX), inténtelo de nuevo, si el problema persiste notifique a su supervisor!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })
    }
  }

  //-================== RELOAD PAGE ==================-\\
  public ReloadPage(): void {
    this.Load_Data(this.ValueTypeCCP, this.Route_Level);
  }

  //-================== FUNCTION FOR DELETE FILE TEMP CCP ==================-\\
  private async Delete_File_Temp_RL_CCP(File_Name_Delete: string): Promise<void> {
    try {

      const ResDelete: Response_CCP = await firstValueFrom(this.Service_CCP.Delete_RL_Temp_CCP({ Name_File: File_Name_Delete }));

      if (!ResDelete.success) {
        throw "ERROR DELETE TEMP";
      }

    } catch (e) {

      Swal.fire({
        title: 'Error al eliminar archivo temporal',
        text: `¡Ocurrió un error al eliminar archivo temporal del reporte generado, notifique a su supervisor el problema!`,
        icon: 'info',
        confirmButtonColor: this.ColorConfirm,
        confirmButtonText: 'Ok',
      })

    }
  }

  //-================== FUNCTION FOR DOWNLOAD REPORT CCP ==================-\\
  private async Download_File_CCP(URL: string, File_Name: string): Promise<boolean> {


    return new Promise((resolve) => {

      const ProgressModal = document.getElementById('ProgressModal') as HTMLDivElement;
      const Progress_Bar_Table = document.getElementById('Progress-Bar-Table') as HTMLElement;


      this.Service_CCP.Download_File_CCP(URL, File_Name).subscribe((Data_Download: Download_CPP) => {


        if (Data_Download.state === "IN_PROGRESS") {
          Progress_Bar_Table.style.width = Data_Download.progress + '%';
        }

        if (Data_Download.state === "DONE") {

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'success',
            title: 'Reporte descargado!'
          })

          resolve(true)
        }


        if (Data_Download.Status === 404 || Data_Download.Status === 500) {


          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })

          Toast.fire({
            icon: 'error',
            title: '¡Error al descargar el reporte, informa a tu supervisor!'
          })

          ProgressModal.classList.remove('active');
          Progress_Bar_Table.style.width = '0%';

          resolve(false);
        }

      })
    })

  }

  //&===================== END FUNCTIONS FOR CARD OPTIONS =====================&\\




  //&===================== FUNCTION FOR FILTERS =====================&\\

  private Generate_Filters(): void {

    this.Filter_Global_Check = {
      Extension: [],
      Model_Year: [],
      Status: [],
      Reviewer_Name: [],
      Approver_Name: [],
      Contributor_Name: [],
      Approver_Assigned: [],
      Approver_Rejected: [],
    };

    for (const CCP of this.Data_Report_List as any) {

      CCP.Date_Created = moment(CCP.Date_Created).utc().toDate();
      CCP.Date_Expiration = moment(CCP.Date_Expiration).utc().toDate();
      CCP.Approver_Rejected = CCP.Approver_Rejected === null ? 'Administrador' : CCP.Approver_Rejected;

      CCP.F_Approver_Assigned = { Value: CCP.Approver_Assigned } as Data_Check;
      CCP.F_Approver_Rejected = { Value: CCP.Approver_Rejected } as Data_Check;


      if (!this.Filter_Global_Check.Model_Year.includes(CCP.Model_Year) && CCP.Model_Year !== null) {
        this.Filter_Global_Check.Model_Year.push(CCP.Model_Year);
      }

      if (!this.Filter_Global_Check.Status.includes(CCP.Status) && CCP.Status !== null) {
        this.Filter_Global_Check.Status.push(CCP.Status);
      }

      if (!this.Filter_Global_Check.Reviewer_Name.includes(CCP.Reviewer_Name) && CCP.Reviewer_Name !== null) {
        this.Filter_Global_Check.Reviewer_Name.push(CCP.Reviewer_Name);
      }

      if (!this.Filter_Global_Check.Approver_Name.includes(CCP.Approver_Name) && CCP.Approver_Name !== null) {
        this.Filter_Global_Check.Approver_Name.push(CCP.Approver_Name);
      }

      if (!this.Filter_Global_Check.Contributor_Name.includes(CCP.Contributor_Name) && CCP.Contributor_Name !== null) {
        this.Filter_Global_Check.Contributor_Name.push(CCP.Contributor_Name);
      }

      if (!this.Filter_Global_Check.Approver_Assigned.some(item => item.Value === CCP.Approver_Assigned) && CCP.Approver_Assigned !== null) {
        this.Filter_Global_Check.Approver_Assigned.push({ Value: CCP.Approver_Assigned })
      }

      if (!this.Filter_Global_Check.Approver_Rejected.some(item => item.Value === CCP.Approver_Rejected) && CCP.Approver_Rejected !== null) {
        this.Filter_Global_Check.Approver_Rejected.push({ Value: CCP.Approver_Rejected })
      }

    }

  }

  //&===================== END FUNCTION FOR FILTERS =====================&\\
}
